import * as Controls from './control/*.js'

export default Controls.control